export default __webpack_public_path__ + "static/media/testimonial-neet.bff02be8.png";